import { queueConclusion } from './queueConclusion';
import { checkinConclusion } from './checkinConclusion.route';

export const conclusionRoutesWithoutHeader = [
  ...checkinConclusion,
];

export const conclusionRoutesWithHeader = [
  ...queueConclusion
];
